import React from 'react';
import { ResultPage } from 'antd-mobile';
import CarServiceComponent from 'utility/CarServiceComponent';
import CarInfoRouter from 'router/mobile/CarInfoRouter';

const CarInfo = () => {
  return (
    <ResultPage
      className="car-info-page"
      description={<ResultDescription />}
      icon={' '}
      details={''}>
      <div className="main-container">
        <CarInfoRouter></CarInfoRouter>
      </div>
    </ResultPage>
  );
};

const ResultDescription = () => {
  return <CarServiceComponent></CarServiceComponent>;
};

export default CarInfo;
